import { Tenancy } from '../../../hooks/useTenancy';
import { SIGNUP_SOURCE } from '../../Footer/JoinEmailForm';
import { QuizAnswers } from '../ProductQuizContext';

export const quizIdentify = (answers: QuizAnswers, tenancy: Tenancy | undefined) => {
  if (!answers.email) {
    return;
  }

  const payload: Record<string, any> = {
    id: answers.email.toLowerCase(),
    email: answers.email,
    source: SIGNUP_SOURCE + '_quiz',
    created_at: Math.round(Date.now() / 1000),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  };

  if (answers.species) {
    payload['Pet Species'] = answers.species.toUpperCase();
  }
  if (answers.petName) {
    payload['pet_name'] = answers.petName;
    payload['Pet Name'] = answers.petName;
  }
  if (answers.breed) {
    payload['Pet Breed'] = answers.breed;
  }
  if (answers.age) {
    payload['Pet Age'] = answers.age;
  }
  if (answers.selectedSize) {
    payload['Pet Size'] = answers.selectedSize;
  }
  if (answers.residence) {
    payload['Pet Residence'] = answers.residence;
  }

  const spendTimeList = Array.from(answers.spendTime).sort();
  if (spendTimeList.length > 0) {
    payload['Pet Spend Time'] = spendTimeList.join(', ');
  }

  const exerciseList = Array.from(answers.exercise).sort();
  if (exerciseList.length > 0) {
    payload['Pet Exercise'] = exerciseList.join(', ');
  }

  const importanceList = Array.from(answers.importance).sort();
  if (importanceList.length > 0) {
    payload['Pet Importance'] = importanceList.join(', ');
  }

  if (tenancy) {
    payload.tenancy = tenancy;
  }

  (window as any)._cio.identify(payload);
};
